export default function transformAvailability(availability: any) {
  const daysOfWeek = [
    'SUNDAY',
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
  ]

  const result: { [key: string]: any } = {}

  daysOfWeek.forEach((day) => {
    const lowercaseDay = day.toLowerCase()
    result[lowercaseDay] = {
      selected: false,
      morning: false,
      afternoon: false,
      night: false,
    }
  })

  availability.forEach((item: any) => {
    const {
      dayWeek, morning, afternoon, night,
    } = item
    const lowercaseDayWeek = dayWeek.toLowerCase()
    result[lowercaseDayWeek] = {
      selected: true,
      morning,
      afternoon,
      night,
    }
  })

  return result
}
